import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "./userSlice";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

export const SessionTimeout = ({ timeoutMinutes }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutTimer = useRef(null);
  const [countdown, setCountdown] = useState(timeoutMinutes * 60);
  const [showPopup, setShowPopup] = useState(false);

  const startLogoutTimer = () => {
    logoutTimer.current = setTimeout(() => {
      setShowPopup(true);
    }, timeoutMinutes * 60 * 1000);
  };

  const resetLogoutTimer = () => {
    clearTimeout(logoutTimer.current);
    setCountdown(timeoutMinutes * 60);
    startLogoutTimer();
  };

  const handleStayLoggedIn = () => {
    setShowPopup(false);
    resetLogoutTimer();
  };

  const handleLogout = () => {
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('assessmentId')
    dispatch(logout());
    navigate("/login");
  };

  useEffect(() => {
    let interval = null;

    const startCountdown = () => {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          } else {
            clearInterval(interval);
            setShowPopup(true);
            return 0;
          }
        });
      }, 1000);
    };

    const handleUserActivity = () => {
      resetLogoutTimer();
      clearInterval(interval);
      startCountdown();
    };

    startCountdown();
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    return () => {
      clearTimeout(logoutTimer.current);
      clearInterval(interval);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
    };
  }, [dispatch, navigate, timeoutMinutes]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div>
      {/* {countdown > 0 ? (
        <p>Session expires in: {formatTime(countdown)}</p>
      ) : (
        <p>Session expired. Please log in again.</p>
      )} */}
      <Dialog open={showPopup} onClose={() => setShowPopup(false)}>
        <DialogTitle>Your session has expired</DialogTitle>
        <DialogContent>
          <p>What would you like to do?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStayLoggedIn}>Stay Logged In</Button>
          <Button onClick={handleLogout}>Log Out</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
